<template>
	<div class="header">
		<div class="container-fluid">
			<!-- Hearer  -->
			<div class="mt-4">
				<div class="card">
					<div class="card-body">
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb">
								<li class="breadcrumb-item fw-bolder">Master Data</li>
								<li class="breadcrumb-item">Contract Type</li>
							</ol>
						</nav>
					</div>
				</div>
			</div>
			<!-- Card  -->
			<div class="card mt-5">
				<div class="card-header">
					<!-- Title -->
					<h4 class="card-header-title">Contract Type</h4>
					<!-- Button -->
					<b-button v-b-modal.modal-1 variant="primary" @click="isAdd = true" v-if="canAdd">
						<span class="fe fe-plus-circle"></span>
						Add Item
					</b-button>
				</div>
				<div class="d-flex justify-content-end mb-3 mt-3 mr-3">
					<label class="align-self-center mb-0 mr-3">Search</label>
					<b-form-input v-model="searchTerm" class="w-auto" placeholder="Type Here..."> </b-form-input>
				</div>
				<vue-good-table
					:line-numbers="true"
					:columns="columns"
					:rows="list"
					:search-options="{
						enabled: true,
						externalQuery: searchTerm,
					}"
					:total-rows="10"
					:pagination-options="{
						enabled: true,
						mode: 'pages',
						position: 'bottom',
						perPage: 10,
						perPageDropdown: [10, 50, 100],
						dropdownAllowAll: false,
						setCurrentPage: 1,
						nextLabel: 'next',
						prevLabel: 'prev',
						rowsPerPageLabel: 'Rows per page',
						ofLabel: 'of',
						pageLabel: 'page',
						allLabel: 'All',
					}"
					style-class="vgt-table border-0 table"
					@on-page-change="onPageChange"
					@on-per-page-change="onPageChange"
				>
					<!-- Loading -->
					<div slot="emptystate" class="text-center font-size-14">No data available</div>
					<!-- Custom Rows -->
					<template slot="table-row" slot-scope="props">
						<!-- Table Action -->
						<span v-if="props.column.field == 'action'">
							<b-button class="no-wrap btn-pill" variant="warning" size="sm" @click="updateData(props.row)" v-if="canEdit">
								<span class="fe fe-edit"></span>
							</b-button>
							<b-button
								class="no-wrap ml-2"
								variant="danger"
								style="margin-left: 5px"
								size="sm"
								@click="deleteData(props.row.id)"
								v-if="canDelete"
							>
								<span class="fe fe-trash-2"></span>
							</b-button>
						</span>
					</template>
				</vue-good-table>
			</div>

			<!-- Modal -->
			<b-modal id="modal-1" hide-footer title="Type Of Contract Form" @hide="closeNotification($event)">
				<form @submit.prevent="saveAdd()" v-if="isAdd === true">
					<div class="form-group">
						<label>Contract Type <span class="text-danger">*</span></label>
						<input
							type="text"
							v-model="modalCreate.name"
							class="form-control"
							placeholder="Type Contract Name"
							v-validate="'required'"
							name="Type Contract Name"
						/>
						<span class="text-sm text-danger" v-show="errors.has('Type Contract Name')">{{
							errors.first('Type Contract Name')
						}}</span>
						<!-- <vue-editor v-model="content" /> -->
					</div>
					<div class="form-group">
						<label>Description <span class="text-danger">*</span></label>
						<textarea
							type="text"
							v-model="modalCreate.description"
							class="form-control"
							placeholder="Description"
							v-validate="'required'"
							name="Description"
						/>
						<span class="text-sm text-danger" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>
					</div>
					<div class="form-group float-end">
						<button class="mt-4 btn btn-outline-light mr-2" type="button" @click="confirmAndCloseModal()">Cancel</button>
						<button class="mt-4 btn btn-primary" type="submit" v-if="isLoading == false">Save</button>
						<button class="mt-4 btn btn-primary" type="button" disabled v-else>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							Loading...
						</button>
					</div>
				</form>

				<form @submit.prevent="saveUpdate()" v-else>
					<div class="form-group">
						<label>Contract Type <span class="text-danger">*</span></label>
						<input
							type="text"
							v-model="modalUpdate.name"
							class="form-control"
							placeholder="Type Contract Name"
							v-validate="'required'"
							name="Type Contract Name"
						/>
						<span class="text-sm text-danger" v-show="errors.has('Type Contract Name')">{{
							errors.first('Type Contract Name')
						}}</span>
					</div>
					<div class="form-group">
						<label>Description <span class="text-danger">*</span></label>
						<textarea type="text" v-model="modalUpdate.description" class="form-control" placeholder="Description" />
					</div>
					<div class="form-group">
						<button
							style="margin-left: auto; float: right"
							class="mt-4 btn btn-primary"
							type="submit"
							v-if="isLoading == false"
						>
							Save
						</button>
						<button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled v-else>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							Loading...
						</button>
						<button
							style="margin-right: auto; float: right"
							class="mt-4 btn btn-outline-primary mr-3"
							type="button"
							@click="$bvModal.hide('modal-1')"
						>
							Cancel
						</button>
					</div>
				</form>
			</b-modal>
		</div>
	</div>
</template>

<script>
	import { authorize } from '@/utils/authorize';
	export default {
		name: 'GentaGendis',
		computed: {
			list() {
				return this.$store.getters['type_contract/list'];
			},
			listTypeContract() {
				return this.$store.getters['type_contract/list'];
			},
		},
		data() {
			return {
				body: {
					page: 1,
					limit: 10,
					type: '',
					order: '',
					name: '',
				},
				modalCreate: {
					name: '',
					description: '',
				},
				modalUpdate: {
					name: '',
					description: '',
				},
				id: '',
				isAdd: true,
				isLoading: false,
				searchTerm: '',
				columns: [
					{
						label: 'Contract Type',
						field: 'name',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Description',
						field: 'description',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Action',
						field: 'action',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
						sortable: false,
					},
				],
				rows: [],
				canAdd: false,
				canEdit: false,
				canDelete: false,
			};
		},

		async mounted() {
			this.getList();
			this.canAdd = await authorize('/type-of-contract', 'create');
			this.canEdit = await authorize('/type-of-contract', 'update');
			this.canDelete = await authorize('/type-of-contract', 'delete');
		},
		methods: {
			updateData(props) {
				this.$bvModal.show('modal-1');
				this.isAdd = false;
				this.modalUpdate = props;
				this.id = props.id;
			},
			saveAdd() {
				this.$validator.validateAll().then(async (res) => {
					if (!res) return false;

					try {
						this.isLoading = true;
						this.$store
							.dispatch('type_contract/CREATE_DATA', this.modalCreate)
							.then((resp) => {
								this.$swal('Saved', 'Your input has been saved', 'success').then((resp) => {
									this.isLoading = false;
									(this.modalCreate = {
										name: '',
										description: '',
									}),
										this.getList();
									this.$bvModal.hide('modal-1');
								});
							})
							.catch((err) => {
								this.$swal('Error', err.response.data.error, 'error');
								this.isLoading = false;
							});
					} catch (error) {
						this.$swal('Error', 'Error while add data', 'error');
					}
				});
			},

			saveUpdate() {
				let body = {
					id: this.id,
					data: { ...this.modalUpdate },
				};
				this.isLoading = true;
				this.$store
					.dispatch('type_contract/UPDATE_DATA', body)
					.then((resp) => {
						this.$swal('Saved', 'Your input has been saved', 'success').then((resp) => {
							this.isLoading = false;
							(this.modalUpdate = {
								name: '',
								description: '',
							}),
								this.getList();
							this.$bvModal.hide('modal-1');
						});
					})
					.catch((err) => {
						this.$swal('Error', err.response.data.error, 'error');
						this.isLoading = false;
					});
			},
			deleteData(id) {
				this.$swal({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#00D97E',
					cancelButtonColor: '#E63757',
					confirmButtonText: 'Yes, delete it!',
					cancelButtonText: 'Cancel',
				}).then((result) => {
					if (result.isConfirmed) {
						this.$store
							.dispatch('type_contract/DELETE_DATA', id)
							.then((resp) => {
								this.getList();
								this.$swal('Deleted!', 'Your data has been deleted', 'success');
							})
							.catch((resp) => {
								this.$swal('Error', 'Error while delete data', 'error');
							});
					}
				});
			},
			async getList() {
				await this.$store.dispatch('type_contract/GET_LIST', this.body);
			},
			// filter
			filterPage() {},

			sorting() {
				this.getList();
			},

			// Pagination
			onPageChange(payload) {
				this.body.limit = payload.currentPerPage;
				this.body.page = payload.currentPage;
			},

			closeNotification(evt) {
				if (evt.trigger === 'backdrop') {
					evt.preventDefault();
				}
				if (evt.trigger === 'headerclose') {
					evt.preventDefault();
					this.confirmAndCloseModal();
				}
			},

			confirmAndCloseModal() {
				this.$swal({
					title: 'Confirm Close?',
					text: 'Are you sure you want to close this page?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#00D97E',
					cancelButtonColor: '#E63757',
					confirmButtonText: 'Yes',
					cancelButtonText: 'No',
				}).then((result) => {
					if (result.isConfirmed) {
						this.$bvModal.hide('modal-1');
					} else {
						console.log('Modal close cancelled from button.');
					}
				});
			},
		},
	};
</script>
